import { Phone, MessageCircle, Mail } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { BookingWidget } from "@/components/BookingWidget";
import { IMG, CONTACT } from "@/data/site";

export default function Book() {
  return (
    <div data-testid="book-page">
      <PageHero overline="Reservations" title="Book Your Stay" subtitle="Send your enquiry and our team confirms availability within hours — no prepayment needed." image={IMG.baobabBeach} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-8">
          <FadeUp><BookingWidget /></FadeUp>
        </div>
        <div className="lg:col-span-4">
          <FadeUp delay={0.15}>
            <div className="border hairline p-8 space-y-8">
              <div>
                <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">Prefer to talk?</p>
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-white hover:text-[#d4af37] transition-colors duration-300" data-testid="book-call-link">
                  <Phone size={17} className="text-[#d4af37]" /> {CONTACT.phone}
                </a>
              </div>
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white hover:text-[#d4af37] transition-colors duration-300" data-testid="book-whatsapp-link">
                <MessageCircle size={17} className="text-[#d4af37]" /> WhatsApp us instantly
              </a>
              <a href={`mailto:${CONTACT.emails.booking}`} className="flex items-center gap-3 text-white hover:text-[#d4af37] transition-colors duration-300" data-testid="book-email-link">
                <Mail size={17} className="text-[#d4af37]" /> {CONTACT.emails.booking}
              </a>
              <div className="pt-6 border-t hairline text-sm text-[#a3a3a3] space-y-3">
                <p>Check-in from 14:00 · Check-out by 11:00</p>
                <p>Breakfast included with all rates</p>
                <p>Children under 5 stay free</p>
                <p>Airport transfers available 24/7</p>
              </div>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
